import { render, staticRenderFns } from "./lib-filter.vue?vue&type=template&id=ffa3befe"
import script from "./lib-filter.vue?vue&type=script&setup=true&lang=js"
export * from "./lib-filter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports